import { render, staticRenderFns } from "./aFeeDetailFeeObj.vue?vue&type=template&id=66fb263c&scoped=true"
import script from "./aFeeDetailFeeObj.vue?vue&type=script&lang=js"
export * from "./aFeeDetailFeeObj.vue?vue&type=script&lang=js"
import style0 from "./aFeeDetailFeeObj.vue?vue&type=style&index=0&id=66fb263c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a6c7c6c484daeff6636bea47b922569f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fb263c",
  null
  
)

export default component.exports